/**
 * @generated SignedSource<<4e136fbc39becd890dec36026398f84a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTaxExemption_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemptionCheckbox_viewer">;
  readonly " $fragmentType": "CheckoutTaxExemption_viewer";
};
export type CheckoutTaxExemption_viewer$key = {
  readonly " $data"?: CheckoutTaxExemption_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemption_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTaxExemption_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemptionCheckbox_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f5473051181d529c9ab522db1bcb2e7c";

export default node;
